import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DataTablesModule } from 'angular-datatables';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatRadioModule } from '@angular/material/radio';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  imports: [
    MatCardModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDividerModule,
    MatStepperModule,
    MatDialogModule,
    MatExpansionModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatButtonToggleModule,
    MatGridListModule,
    MatTableModule,
    MatProgressSpinnerModule,
    DataTablesModule,
    MatDatepickerModule,
    MatNativeDateModule,
    AngularEditorModule,
    PopoverModule,
    BsDatepickerModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatRadioModule,
  ],
  exports: [
    MatCardModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDividerModule,
    MatStepperModule,
    MatDialogModule,
    MatExpansionModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatButtonToggleModule,
    MatGridListModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    DataTablesModule,
    MatDatepickerModule,
    MatNativeDateModule,
    AngularEditorModule,
    PopoverModule,
    BsDatepickerModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatRadioModule,
  ],
})
export class MaterialModule {}
